export default "__VITE_ASSET__699b0e75__"